import {
	Button,
	HStack,
	Input,
	Text,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { RequestStatus } from '@montel/montelpro-shared-components/enums';
import { DEVELOPER_API_IMPORT_YOUNIUM_ACCOUNTS } from 'apiRoutes';
import { Table } from 'components/tables/Table';
import { Company } from 'domain/company/Company';
import useSubmit, { POST } from 'hooks/useSubmit';
import { companyTableColumns } from 'pages/Companies/companyTableColumns';
import { FunctionComponent, useMemo, useState } from 'react';

const YouniumAccountImportTool: FunctionComponent = () => {
	const [createdCompanies, setCreatedCompanies] = useState<Company[]>([]);
	const [batchSize, setBatchSize] = useState<number>(100);
	const [totalAccounts, setTotalAccounts] = useState<number | undefined>(
		undefined,
	);

	const [submit, status] = useSubmit(
		`${DEVELOPER_API_IMPORT_YOUNIUM_ACCOUNTS}`,
		POST,
		{
			messageOnSuccess: 'Accounts imported successfully',
			messageOnError: 'Error importing accounts',
			showApiError: true,
		},
	);

	const onSubmit = async () => {
		const result = await submit({
			batchSize: batchSize,
		});

		if (result && result.data) {
			setCreatedCompanies(result.data.createdCompanies);
			setTotalAccounts(result.data.totalCount);
		}
	};

	const columns = useMemo(() => {
		const columns = [
			companyTableColumns.name(),
			companyTableColumns.created(),
			companyTableColumns.country(),
		];

		return columns;
	}, []);

	return (
		<>
			<Text>Import accounts from Younium</Text>
			<HStack wrap="nowrap">
				<Input
					label="Batch Size (max 200)"
					type="text"
					autoComplete="off"
					name="batchSize"
					value={batchSize}
					required
					onChange={(event) => setBatchSize(event.target.value)}
				/>
			</HStack>
			<Button
				onClick={onSubmit}
				type="submit"
				text="Import Accounts"
				loadingText="Importing accounts ..."
				isLoading={status === RequestStatus.LOADING}
			/>
			{totalAccounts !== undefined && (
				<VStack>
					<Text>
						{createdCompanies.length} accounts were imported.
					</Text>
					<Text>
						Total accounts remaining in Younium to be imported:{' '}
						{totalAccounts - createdCompanies.length}
					</Text>
				</VStack>
			)}
			<Table<Company>
				header="Imported Accounts"
				data={createdCompanies}
				columns={columns}
				noDataText="No accounts imported yet"
				showRowCount
			/>
		</>
	);
};

export default YouniumAccountImportTool;
